import type { ScaffoldTemplate } from '../scaffold-engine.js';
import {
  getEngineeringFiles,
  getPreCommitHook,
  mergeEngineeringDeps,
} from './shared-engineering.js';

export const BASE_CLI_TEMPLATE: ScaffoldTemplate = {
  name: 'base',
  description: 'A basic CLI application using @dyyz1993/xcli-core',
  variables: [
    {
      name: 'description',
      description: 'Project description',
      default: 'A CLI tool built with @dyyz1993/xcli-core',
    },
    {
      name: 'author',
      description: 'Author name',
      default: '',
    },
  ],
  files: [
    {
      path: 'package.json',
      content: mergeEngineeringDeps(`{
  "name": "{{projectName}}",
  "version": "0.1.0",
  "description": "{{description}}",
  "type": "module",
  "bin": {
    "{{projectName}}": "dist/cli.js"
  },
  "main": "dist/index.js",
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "lint": "eslint src/",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@dyyz1993/xcli-core": "^0.9.0",
    "zod": "^3.25.0"
  },
  "devDependencies": {
    "@types/node": "^20.0.0",
    "tsup": "^8.0.0",
    "typescript": "^5.0.0"
  }
}`),
    },
    {
      path: 'tsconfig.json',
      content: `{
  "compilerOptions": {
    "target": "ES2022",
    "module": "ESNext",
    "moduleResolution": "bundler",
    "strict": true,
    "esModuleInterop": true,
    "skipLibCheck": true,
    "declaration": true,
    "sourceMap": true,
    "outDir": "dist",
    "rootDir": "src"
  },
  "include": ["src/**/*", "bin/**/*"],
  "exclude": ["node_modules", "dist"]
}`,
    },
    {
      path: 'tsup.config.ts',
      content: `import { defineConfig } from 'tsup';

export default defineConfig([
  {
    entry: ['src/index.ts'],
    format: ['esm'],
    dts: true,
    clean: true,
  },
  {
    entry: ['bin/cli.ts'],
    format: ['esm'],
    dts: false,
    clean: false,
  },
]);`,
    },
    {
      path: 'src/index.ts',
      content: `export { version } from './version.js';
`,
    },
    {
      path: 'src/version.ts',
      content: `export const version = '0.1.0';
`,
    },
    {
      path: 'bin/cli.ts',
      content: `#!/usr/bin/env node
import { Core } from '@dyyz1993/xcli-core';

const app = new Core({
  name: '{{projectName}}',
  version: '0.1.0',
  description: '{{description}}',
  configDirName: '.{{projectName}}',
  envPrefix: '{{projectName}}',
  pluginDirs: [],
});

// Register your plugins here
// app.loadPlugins();

await app.run(process.argv.slice(2));
`,
      mode: 0o755,
    },
    {
      path: '.gitignore',
      content: `node_modules/
dist/
*.tgz
.env
`,
    },
    ...getEngineeringFiles(),
    {
      path: '.husky/pre-commit',
      content: getPreCommitHook(),
      mode: 0o755,
    },
    {
      path: 'README.md',
      content: `# {{projectName}}

{{description}}

## Install

\`\`\`bash
npm install
\`\`\`

## Build

\`\`\`bash
npm run build
\`\`\`

## Usage

\`\`\`bash
node dist/cli.js <command>
\`\`\`

## Development

\`\`\`bash
npm run dev
\`\`\`
`,
    },
  ],
};
